import { Component } from "react";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import withAuth from "../../components/withAuth";
import { Tab, Tabs } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import MyFormsTab from "../../components/HumanResources/MyFormsTab";
import FormsAsManagerTab from "../../components/HumanResources/FormsAsManagerTab";
import HumanResourcesTab from "../../components/HumanResources/HumanResourcesTab";
import { connect } from "react-redux";
import { setHRTabId } from "../../redux/humanResources/humanResourcesActions";
import { MODULE_DRH } from "../../redux/authorizedApps/authorizedAppsConstants";

class HumanResources extends Component {
    handleChange = (event, value) => {
        this.props.setHRTabId(value);
    };

    handleChangeIndex = (index) => {
        this.props.setHRTabId(index);
    };

    render() {
        let views = [<MyFormsTab key="0" {...this.props} />, <FormsAsManagerTab key="1" {...this.props} />];

        let tabs = [
            <Tab key="0" label={"Mes entretiens"} />,
            <Tab key="1" label={"Entretiens de mes collaborateurs"} />,
        ];

        this.props.authorizedApps.some((aa) => aa.code === MODULE_DRH) &&
            views.push(<HumanResourcesTab key="2" {...this.props} />) &&
            tabs.push(<Tab key="2" label={"Tous les entretiens"} />);

        return (
            <div>
                <AppBar position="static" color="default">
                    <Tabs
                        value={this.props.tabId}
                        onChange={this.handleChange}
                        variant="fullWidth"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {tabs}
                    </Tabs>
                </AppBar>
                <SwipeableViews axis="x" index={this.props.tabId} onChangeIndex={this.handleChangeIndex}>
                    {views}
                </SwipeableViews>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        tabId: state.forms.tabId,
        authorizedApps: state.authorizedApps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setHRTabId: (selectedTab) => dispatch(setHRTabId(selectedTab)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(HumanResources);
